export default __webpack_public_path__ + "static/media/goshen88.d25467d7.jpg";